import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import { NavLink } from "react-router-dom";
// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
	Select,
	InputLabel,
	Input,
	// MenuItem,
	Modal,
	Backdrop,
	Fade,
	FormHelperText,
	NativeSelect,
	Button,
	Breadcrumbs,
	Typography,
} from "@material-ui/core";
import { makeStyles, createMuiTheme, MuiThemeProvider} from "@material-ui/core/styles";

// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
//cookies
import {get_cookies} from "../../../components/Cookies/Cookies";
import numeral from "numeral";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
}));

const AccountUpgradeBranch = () => {
	const [uniqueID, setUniqueId] = useState('');
	const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [downloadFlag, setDownloadFlag] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: addDays(new Date(), 7),
	});
	const classes = useStyles();
	
	const [useridNo, setuseridNo] = useState(get_cookies('branchidno'));
	// console.log(uniqueID);
	// Data Fetching
	useEffect(() => {
		data();
	}, []);

	useEffect(() => {
		if(posts.length > 0){
			setDownloadFlag(true);
		}else{
			setDownloadFlag(false);
		}
	}, [posts]);
	//search button
	const dataFilter = async () => {
		setDataLoaded(false);

		const params = {
			jc_user_id_no: useridNo,
		}
		if(uniqueID != ""){
			params.unique_id=uniqueID;
		}else{
			params.date_from= format(dateRange.startDate, "yyyy-MM-dd"); //format(dateRange.startDate, "yyyy/MM/dd/")
			params.date_to= format(dateRange.endDate, "yyyy-MM-dd");
		}
        await axios.get(
			process.env.REACT_APP_API_URL+'table_data_account_branch', {params
//             params:{
//   //format(dateRange.endDate, "yyyy/MM/dd/")
//                 jc_user_id_no: useridNo,
// 		unique_id: uniqueID
//             }
        }).then((res)=>{
                // console.log('s',res)
			setPosts(res.data.data);
		}).catch((error)=>{
			// console.log(error.message);
		})
		setDataLoaded(true);
    }

	const data = async () => {
		setDataLoaded(true);
	};

	const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};
	const columns = [
		{
			name: "reference_no",
			label: "Reference No",
		},
		{
			name: "main_reference_no",
			label: "Main Reference No",
												options: {
										customBodyRender: (value, tableMeta, updateValue) => {

											if(value ==""){
												return "-";
											}else{
												return value;
											}

										  }
										}
		},
		{
			name: "date_created",
			label: "Date Upgraded",
		},
		{
			name: "idno",
			label: "ID No",
		},
		{
			name: "fullname",
			label: "Name",
		},
		{
			name: "amount",
			label: "Paid Amount",
									options: {
										customBodyRender: (value, tableMeta, updateValue) => {
											return (
													<div style={{textAlign:"right"}}>{numeral(value).format('0,0.00')}</div>
											);
										  }
										}
		},
		// {
		// 	name: "old_country",
		// 	label: "From Country",
		// },
		{
			name: "old_atype",
			label: "Past Account Type",
		},
		// {
		// 	name: "new_country",
		// 	label: "To Country",
		// },
		{
			name: "new_atype",
			label: "Current Account ype",
		},
		{
			name: "is_released",
			label: "Status",
			options: {
				customBodyRenderLite: (dataIndex)=> {
					let is_released =  posts[dataIndex].is_released;
					let branchidno =  posts[dataIndex].branchcode;
					let released_by =  posts[dataIndex].released_by;
					// console.log('23232',get_cookies('branchidno'))
					// const branchidno = tableMeta.rowData[tableMeta.columnData.findIndex(col => col.name === "branchcode")];
					if(branchidno !== get_cookies('branchidno')){

						return released_by === null || is_released === ""
						? `Branch Releasing`
						: `Released`;
					}else{
						return is_released === 1 || is_released === "1"
						? `Released`
						: `Waiting for Release`;
					}
				  

				      }
			      }
		},
		{
			name: "action",
			label: "Action",
			options: {
				download: false, //exclude this column in csv export
				sort:false, 
				filter: false, 
				customBodyRenderLite: (dataIndex) => {
					let id =  posts[dataIndex].id;
					let status =  posts[dataIndex].status;
					// collectionviewdetails
					// collectionallocat
						return(
							<Grid container spacing={1}>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={4}>
									{get_cookies('can_process') == 1 ?
										<NavLink to={"/sales/account-upgrade-view/"+id+"/"+useridNo}>
											<Button variant="contained" color="primary" style={{backgroundColor: "#4caf50", color:"#fff"}}>
												View
											</Button>	
										</NavLink> 
											:null}
									</Grid>
							</Grid>
						)
                                        }
			},
	 	}
	];

	const options = {
		filter: false,
		// filterType: "dropdown",
		selectableRows: "none",
		filterType: "multiselect",
		responsive: "standard",
		download: false,  //add this
		print: false, //add this
		viewColumns :false,
		setFilterChipProps: (colIndex, colName, data) => {
			//console.log(colIndex, colName, data);
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},
		downloadOptions: {
			filename : 'CollectionTransactionHistory.csv' //change filename of csv
		}
		// tableBodyHeight,
	};

    const style = {
		marginBottom: '1rem',
		marginTop:"2.5em",
	};

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<ShoppingCartIcon />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/WholesaleMenu">
						<h2 className="header-title">Wholesale Set</h2>
					</NavLink>  
					<Typography color="textPrimary">Paid Account Upgrade Summary (Branch)</Typography>
				</Breadcrumbs>
			</div>
			<div className="page-container">
				<div style={style}>
                        <Grid container spacing={3} alignItems="center">
                            <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                <TextField
                                    id="outlined-basic"
                                    label="Select Date"
                                    variant="outlined"
                                    onFocus={() => setOpen(true)}
                                    fullWidth={true}
                                    autoComplete="off"
                                    value={`${format(
                                        dateRange.startDate,
                                        "MM/dd/yyyy"
                                    )} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
                                />
                                <DateRangePicker
                                    open={open}
                                    toggle={toggle}
                                    onChange={(range) => dateRangeHandler(range)}
                                /> 
                            </Grid>
			    <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
								<TextField 
								fullWidth
									id="outlined-search" 
									label="Search by Reference No" 
									type="search" 
									variant="outlined" 
									value={uniqueID}
									onChange={e => {
										setUniqueId(e.target.value);
									}}
								/>
                            </Grid>
			    <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                <Button variant="contained"  color="primary"  onClick={() => {dataFilter()}}>Search</Button>
                            </Grid>
                        </Grid>        
                    </div>

				{!dataLoaded ? (
					<Preloader />
				) : (
						<MUIDataTable
							title={
								<div>
									<h3 className="header-title" style ={{color: "#339933"}}>
									Account Upgrade (Branch)
									</h3>
								</div>
							}
							data={posts}
							columns={columns}
							options={options}
						/>
				)}
			</div>
		</div>
	);
};

export default AccountUpgradeBranch;